import { Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import { Flex } from '@jisr-hr/ds-beta'
import { NPS_SCORE } from '../../constants'

export type TRadioWithContentOption = {
  label: string
  value: string | number | boolean
  testId?: string
}

type TRadioWithContent = {
  value: string | undefined
  handleChange: (text: number) => void
}

export function NpsAnswers({ value, handleChange }: TRadioWithContent) {
  const containerStyles = (selected: boolean) =>
    `w-[60px] h-[60px] flex flex-col items-center justify-center gap-2 rounded-md cursor-pointer bg-color-bg-neutral-lightest-default hover:bg-color-bg-neutral-lightest-hovered ${
      selected ? 'shadow-md bg-color-bg-neutral-lightest-pressed' : ''
    }`

  const renderScoreOptions = (scores: typeof NPS_SCORE) => {
    return scores.map((score) => {
      const selected = score.value?.toString() === value?.toString()
      return (
        <div
          key={score.value}
          onClick={() => handleChange(score.value)}
          className={containerStyles(selected)}
        >
          <Typography
            variant="interface/medium/l"
            text={score.value}
          />
        </div>
      )
    })
  }

  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <Flex
          dir="row"
          className="gap-6"
        >
          {renderScoreOptions(NPS_SCORE.slice(0, 6))}
        </Flex>
        <br />
        <Flex
          dir="row"
          className="gap-6"
        >
          {renderScoreOptions(NPS_SCORE.slice(6))}
        </Flex>
        <div className="mt-6" />
        <Flex
          dir="row"
          justifyBetween
          className="w-full mt-4"
        >
          <Typography
            variant="interface/medium/s"
            text={i18n.t('label.survey_-_very_unlikely')}
          />
          <Typography
            variant="interface/medium/s"
            text={i18n.t('label.survey_-_very_likely')}
          />
        </Flex>
      </div>
    </>
  )
}
